export const ROLES = {
  SUPER_USER: "SuperUser",
  ORGANISATION_ADMIN: "OrganisationAdmin",
  ORGANISATION: "Organisation",
  PRACTITIONER: "Practitioner",
  MEMBER: "Member",
};
